import ActionsPopover from "src/components/ActionsPopover/ActionsPopover";
import { usePropertyContext } from "../context/usePropertyContext";

export const PropertyActionsPopover = () => {
    const { menuItems, rowMenuAnchor, setRowMenuAnchor } = usePropertyContext();

    return <ActionsPopover menuItems={menuItems} anchor={rowMenuAnchor} closeWindow={() => setRowMenuAnchor(null)} />;
};
